<template>
  <tr
    v-bind:key="result.id">
    <td>
      <div class="form-check">
       <b-form-checkbox
              class="col-md-12 noselect"
              type="checkbox"
              v-model="checked"
              @change="changeChecked"/>
      </div>
    </td>
    <td>{{ result.name }}</td>
    <td>{{ result.address }}</td>
    <td>
      <div v-for="role in result.roles"
        :key="role + result.id">
        {{ role }}
      </div>
    </td>
    <td>
      <router-link
        :to="{ name: 'contact', params: {
        id: result.id }}"
        class="btn btn-secondary btn-sm">
        View
      </router-link>
    </td>
  </tr>
</template>
<script>

export default {
  name: 'ContactSearchResultRow',
  props: {
    result: {
      type: Object,
    },
  },
  data() {
    return {
      checked: true,
    };
  },
  methods: {
    changeChecked(isChecked) {
      if (isChecked) {
        this.$store.dispatch('Contact/addSelectedSearchContact', this.result.id);
      } else {
        this.$store.dispatch('Contact/removeSelectedSearchContact', this.result.id);
      }
    },
  },
};
</script>
